// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3t0jm","footer":"ModalError_footer__81Cf5"};